import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { db } from '../../../firebase';
import { collection, getDocs, addDoc, doc, setDoc } from 'firebase/firestore';

const CreateRoleModal = ({ show, handleClose, handleSaveCreate }) => {
    const [nom, setNom] = useState('');




    const saveChanges = async () => {
        try {
            const newRoleRef = doc(collection(db, 'roles')); 
            const newRole = { id: newRoleRef.id, nom }; 
            await setDoc(newRoleRef, newRole); 
            handleSaveCreate(newRole);
            handleClose();
        } catch (error) {
            console.error("Error creating role: ", error);
        }
    };

    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Créer un rôle</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group controlId="formNom">
                        <Form.Label>Nom</Form.Label>
                        <Form.Control
                            type="text"
                            value={nom}
                            onChange={(e) => setNom(e.target.value)}
                        />
                    </Form.Group>
                  
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Annuler
                </Button>
                <Button variant="primary" onClick={saveChanges}>
                    Enregistrer
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CreateRoleModal;
